import { useEffect, useMemo, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";

const SEARCH_DEBOUNCE_MS = 300;

const searchPattern = (term: string) => `%${term.replace(/([\\%_])/g, "\\$1")}%`;

export const useProjectsSearch = (datasource: any) => {
	const [searchTerm, setSearchTerm] = useState("");
	const [query, setQuery] = useState("");

	useEffect(() => {
		const timer = setTimeout(() => {
			const nextQuery = searchTerm.trim();
			if (nextQuery === query) return;
			unstable_batchedUpdates(() => {
				if (datasource.currentPage !== 1) datasource.setCurrentPage(1);
				setQuery(nextQuery);
			});
		}, SEARCH_DEBOUNCE_MS);
		return () => clearTimeout(timer);
	}, [searchTerm, query, datasource]);

	const searchParams = useMemo(() => (query ? { q: searchPattern(query) } : {}), [query]);

	return { searchTerm, setSearchTerm, searchParams };
};

export default useProjectsSearch;
